import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "name", "output" ]

  greet() {
    console.log('teeest');
    this.outputTarget.textContent = `Hello, ${this.nameTarget.value}!`
  }
}